<style lang="scss" src='./StationAlerts.scss' scoped></style>
<template src="./StationAlerts.html"></template>

<script>
import {
  GetOpenedAlertByStation,
} from '@/api/index';

import { mapMutations, mapState } from 'vuex';
import StationDetails from './stationAlert/StationDetails.vue';

export default {
  name: 'StationAlerts',
  components:{
    StationDetails
  },
  props: {
    station: {
      required: false,
    },
  },
  data() {
    return ({
      alerts: [],
      loading: false,
      selectedAlert: null
    });
  },
  watch: {
    station: function (newStation, oldStation) {
      if (newStation && oldStation && newStation.station_id !== oldStation.station_id) {
        this.loadData();
      }
    }
  },

  computed:{
    ...mapState('sensors', ['showAlertList'])
  },

  methods: {

    getRssiIcon() {
      // eslint-disable-next-line
      return require(`@/assets/img/sensor/ic_rssi_bad.png`);
    },

    async loadAlerts() {
      this.loading = true;
      this.alerts = [];
      const alertResponse = await GetOpenedAlertByStation(this.station.station_id);
      if (alertResponse) {
        this.alerts = alertResponse.alerts;
      }
      this.loading = false;
    },

    loadData() {
      if (this.station){
        this.loadAlerts();
        this.setShowAlertList(true);
      }
    },

    getThresholdViolation(alert) {
      const threshold = alert.station.thresholds.find(t => t.alert_type_id === alert.alert_type_id);
      if (threshold) {
        const value = alert.violation === 'READING_HIGH' ? threshold.max : threshold.min;
        return this.G_getMeasurement({ val: value,
                                    uom: alert.alert_type.uom,
                                    addUnit: true, invertUOM: false });
      }

    },

    showAlertDetails(alert){
      this.selectedAlert = alert;
      this.setShowAlertList(false);
    },

    ...mapMutations('sensors', ['setShowAlertList'])
  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Stations Alerts");
      this.$analytics.logEvent("web_stations_alerts");
    }

    this.loadData();
  },
};
</script>
